import React, { useState } from 'react';
import FAQItem from './FAQItem';
import { faqData } from './faqData';

export default function FAQList() {
  const [openItems, setOpenItems] = useState(new Set([]));

  const toggleItem = (id) => {
    setOpenItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  return (
    <div className='border border-white/16 rounded-lg overflow-hidden'>
      {faqData.map((item, index) => (
        <React.Fragment key={item.id}>
          <FAQItem
            question={item.question}
            answer={item.answer}
            isOpen={openItems.has(item.id)}
            onToggle={() => toggleItem(item.id)}
          />
          {index < faqData.length - 1 && (
            <div className='border-b border-white/16' />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
